










import { Vue, Component } from 'vue-property-decorator';
import VerFacturaciones from '@/pantallas/SucursalVirtual/VerFacturacion/VerFacturaciones.vue';

@Component({
  components: { VerFacturaciones },
})
export default class VerFacturacionPantalla extends Vue {}
